export default {
    // 登录  username password
    login: {
        url: '/mobile/login'
    },
    // token登录 token
    centralizedLogin: {
        url: '/mobile/centralizedLogin'
    },
    // 退出登录
    loginOut: {
        url: '/mobile/loginOut'
    },
    // 获取看板菜单
    getMenuList: {
        url: '/mobile/getMenuList'
    },
    // pad周报初始化
    initWeeklyTotal: {
        url: '/mobile/initWeeklyTotal'
    },
    // phone周报初始化
    initWeeklyTotal_mobile: {
        url: '/mobile/initWeeklyTotal_mobile'
    },
    /**
     * 获取周报
     * userId  
     * date  
     **/ 
    queryWeeklyTotal: {
        url: '/mobile/queryWeeklyTotal'
    },
    //  yearMonth userId  个人月销售和项目数据
    getWeekReportSaleData: {
        url: '/mobile/getWeekReportSaleData'
    },
    /**
     * 获取员工销售数据
     * 参数  userId   yearMonth  
     **/ 
    getUserTargetSaleInfo: {
        url: '/mobile/getUserTargetSaleInfo'
    },
    // 按月获取销售数据 yearMonth
    getCompanyMonthSaleData: {
        url: '/mobile/getCompanyMonthSaleData'
    },
    //  部门月销售数据   yearMonth   
    getDeptMonthSaleData: {
        url: '/mobile/getDeptMonthSaleData'
    },
    //  部门月销售数据   yearMonth   
    getUserMonthSaleData: {
        url: '/mobile/getUserMonthSaleData'
    },
    //  销售订单趋势   year  ONE  近一年  HALF  进半年  其他直接传年份   companyId
    getSaleTrend: {
        url: '/mobile/getSaleTrend'
    },
    //  毛利趋势   year  ONE  近一年  HALF  进半年  其他直接传年份   companyId
    getGrossProfitTrend: {
        url: '/mobile/getGrossProfitTrend'
    },
    //  自营趋势   year  ONE  近一年  HALF  进半年  其他直接传年份   companyId
    getZySaleTrend: {
        url: '/mobile/getZySaleTrend'
    },
    //  销售同比   year  companyId
    getSaleYearOnYear: {
        url: '/mobile/getSaleYearOnYear'
    },
    //  毛利同比   year  companyId
    getGrossProfitYearOnYear: {
        url: '/mobile/getGrossProfitYearOnYear'
    },
    //  存货类型
    getGoodsTypeStockMoney: {
        url: '/mobile/getGoodsTypeStockMoney'
    },
    // 供应商销售额 yearMonth 
    getPurMonthSaleData: {
        url: '/mobile/getPurMonthSaleData'
    },
    // 客户月销售额  yearMonth  
    getDistMonthSaleData: {
        url: '/mobile/getDistMonthSaleData'
    },
    // 合作商月销售额  yearMonth  
    getParMonthSaleData: {
        url: '/mobile/getParMonthSaleData'
    },
    // 品类月销售额  yearMonth 
    getCateMonthSaleData: {
        url: '/mobile/getCateMonthSaleData'
    },
    // 员工销售明细,全年累计  yearMonth  必传
    getUserListYearSaleData: {
        url: '/mobile/getUserListYearSaleData'
    },
    // 员工销售明细  yearMonth  必传   userId   非必传   
    getUserListMonthSaleData: {
        url: '/mobile/getUserListMonthSaleData'
    },
    // 员工销售明细（用于展示表格）  yearMonth  必传   userId   非必传   
    getUserListMonthSaleDataForShow: {
        url: '/mobile/getUserListMonthSaleDataForShow'
    },
    // 员工列表(员工销售明细前置options)  yearMonth   
    getUserList: {
        url: '/mobile/getUserList'
    },
    // 员工全年销售列表  yearMonth  
    getUserYearSaleList: {
        url: '/mobile/getUserYearSaleList'
    },
    // 员工业绩累计 yearMonth  userId    
    getUserSumMonthSaleData: {
        url: '/mobile/getUserSumMonthSaleData'
    },
    // 供应商趋势  year  companyId  purchaserName  
    getPurSaleTrend: {
        url: '/mobile/getPurSaleTrend'
    },
    // 供应商毛利趋势 year  companyId  purchaserName  
    getPurMlTrend: {
        url: '/mobile/getPurMlTrend'
    },
    // 供应商品类销售占比  yearMonth  companyId  purchaserName  
    getPurCateMonthSaleData: {
        url: '/mobile/getPurCateMonthSaleData'
    },
    // 客户销售趋势   year  distName   
    getDistSaleTrend: {
        url: '/mobile/getDistSaleTrend'
    },
    // 客户商品品类月销售额   yearMonth  distName   
    getDistCateMonthSaleData: {
        url: '/mobile/getDistCateMonthSaleData'
    },
    // 月员工正向销售及毛利占比（当月占比饼图）  yearMonth  
    getUserListMonthPositiveSaleData: {
        url: '/mobile/getUserListMonthPositiveSaleData'
    },
    // 累计员工正向销售及毛利占比（累计占比图）  yearMonth  
    getUserSumMonthPositiveSaleData: {
        url: '/mobile/getUserSumMonthPositiveSaleData'
    },
    // 供应商月销售占比  yearMonth  companyId    
    getPurMonthSalePercent: {
        url: '/mobile/getPurMonthSalePercent'
    },
    // 供应商月毛利前五 yearMonth   companyId  
    getPurMonthMlData: {
        url: '/mobile/getPurMonthMlData'
    },
    // 供应商月毛利占比 yearMonth  companyId  
    getPurMonthMlDataPercent: {
        url: '/mobile/getPurMonthMlDataPercent'
    },

    // 供应商年销售额 yearMonth  companyId   
    getPurYearSaleData: {
        url: '/mobile/getPurYearSaleData'
    },
    // 供应商年销售占比  yearMonth  companyId  
    getPurYearSalePercent: {
        url: '/mobile/getPurYearSalePercent'
    },
    // 供应商年毛利前五  yearMonth  companyId  
    getPurYearMlData: {
        url: '/mobile/getPurYearMlData'
    },
    // 供应商年毛利占比  yearMonth  companyId  
    getPurYearMlDataPercent: {
        url: '/mobile/getPurYearMlDataPercent'
    },
    // 客户月销售额占比 yearMonth  companyId  
    getDistMonthSalePercent: {
        url: '/mobile/getDistMonthSalePercent'
    },
    // 客户月毛利占比 yearMonth  companyId    客户月毛利占比
    getDistMonthMlDataPercent: {
        url: '/mobile/getDistMonthMlDataPercent'
    },
    // 客户月毛利前五 yearMonth  companyId  
    getDistMonthMlData: {
        url: '/mobile/getDistMonthMlData'
    },
    // 客户年销售额  yearMonth  companyId  
    getDistYearSaleData: {
        url: '/mobile/getDistYearSaleData'
    },
    // 客户年销售额占比  yearMonth  companyId  
    getDistYearSalePercent: {
        url: '/mobile/getDistYearSalePercent'
    },
    // 客户年毛利前五  yearMonth  companyId  
    getDistYearMlData: {
        url: '/mobile/getDistYearMlData'
    },
    // 客户年毛利占比  yearMonth  companyId  
    getDistYearMlDataPercent: {
        url: '/mobile/getDistYearMlDataPercent'
    },
    // 客户毛利趋势 year  companyId  distName  
    getDistMlTrend: {
        url: '/mobile/getDistMlTrend'
    },
    // 资金指标  companyId     
    getTotalMoney: {
        url: '/mobile/getTotalMoney'
    },
    // 预付余额top10  companyId  
    getAdvanceBalanceList: {
        url: '/mobile/getAdvanceBalanceList'
    },
    // 应收余额top10  companyId  
    getReceiveBalanceList: {
        url: '/mobile/getReceiveBalanceList'
    },
    // 银行余额趋势 companyId  bankOrderNum  yearMonth  days(默认为空或者不传)   
    getBankTrend: {
        url: '/mobile/getBankTrend'
    },
    // 银行列表 companyId  
    getBankList: {
        url: '/mobile/getBankList'
    },

    // 合作商月销售额top5 companyId  yearMonth
    getParMonthSaleData: {
        url: '/mobile/getParMonthSaleData'
    },
    // 合作商月销售占比 yearMonth  companyId  
    getParMonthSalePercent: {
        url: '/mobile/getParMonthSalePercent'
    },
    // 合作商月毛利top5 yearMonth  companyId  
    getParMonthMlData: {
        url: '/mobile/getParMonthMlData'
    },
    // 合作商月毛利占比 year  companyId  
    getParMonthMlPercent: {
        url: '/mobile/getParMonthMlPercent'
    },
    // 合作商年销售额top5 year  companyId  
    getParYearSaleData: {
        url: '/mobile/getParYearSaleData'
    },
    // 合作商年销售占比 year  companyId  
    getParYearSalePercent: {
        url: '/mobile/getParYearSalePercent'
    },
    // 合作商年毛利top5 year  companyId  
    getParYearMlData: {
        url: '/mobile/getParYearMlData'
    },
    // 合作商年毛利占比 year  companyId  
    getParYearMlPercent: {
        url: '/mobile/getParYearMlPercent'
    },
    // 合作商销售趋势 year  companyId  partnerName
    getParSaleTrend: {
        url: '/mobile/getParSaleTrend'
    },
    // 合作商毛利趋势 year  companyId  partnerName
    getParMlTrend: {
        url: '/mobile/getParMlTrend'
    },
    // 获取公用合作商  companyId  
    getCommonParList: {
        url: '/mobile/getCommonParList'
    },
    // 预付余额top10_合作商 companyId  
    getAdvanceBalanceListForPar:{
        url: '/mobile/getAdvanceBalanceListForPar'
    },
    // 应收余额top10_合作商  companyId  
    getReceiveBalanceListForPar:{
        url: '/mobile/getReceiveBalanceListForPar'
    },
    // 经营数据看板 图表接口 year
    getCaptailTrend:{
        url: '/mobile/getCaptailTrend'
    },
    // 经营数据看板 数据接口 yearMonth
    getCaptailMonthData:{
        url: '/mobile/getCaptailMonthData'
    },

    // 业绩看板  yearMonth   在线业绩数据查询
    getOnLineSaleData:{
        url: '/mobile/getOnLineSaleData'
    },
    // 业绩看板  yearMonth  子公司数据查询
    getSubCompanySaleData:{
        url: '/mobile/getSubCompanySaleData'
    },

    // 往期优质客户
    queryLastDistSaleTop10:{ 
        url: '/mobile/queryLastDistSaleTop10'
    },
    // 未来三个月_往期优质客户
    queryFutureDistSaleTop10:{ 
        url: '/mobile/queryFutureDistSaleTop10'
    },

    // 销售毛利红黑榜  dateType(month 月  season 季  year 年)   yearMonth
    queryRedAndBlackList:{ 
        url: '/mobile/queryRedAndBlackList'
    },
    // 上月红黑榜首 yearMonth
    getLastMonthRedAndBlack:{ 
        url: '/mobile/getLastMonthRedAndBlack'
    },

    // yearMonth   周销售数据
    getWeekLySaleData:{ 
        url: '/mobile/getWeekLySaleData'
    },
    //  yearMonth   季度销售数据
    getSeasonSaleData:{ 
        url: '/mobile/getSeasonSaleData'
    },
    //    yearMonth 员工销售明细   累计
    getUserListSumSaleData:{ 
        url: '/mobile/getUserListSumSaleData'
    },
    // dataType (COMPANY 查公司 PAR 合作商 PROJECT 项目) keyWords(默认空 合作商传合作商名字 项目传项目名字)  
    // companyId(集团ALL 其他子公司传ID 公用页面公司选择的) yearMonth 年月 获取公司订单列表
    getCompanyOrderList:{
        url:'/mobile/getCompanyOrderList'
    },
    // yearMonth  conpanyId 集团年月销售数据(可切换子公司
    getCompanyMonthSaleData_new:{
        url:'/mobile/getCompanyMonthSaleData_new'
    },
    //   司列表初始化
    getIdcCompanyList:{
        url:'/mobile/getIdcCompanyList'
    },
    //    yearMonth conpanyId 合作销售数据
    getParMonthSaleData_new:{
        url:'/mobile/getParMonthSaleData_new'
    },
    //    yearMonth conpanyId  项目跟踪
    getProjectSaleData:{
        url:'/mobile/getProjectSaleData'
    },
    getCompanyDeptSaleMonthData_new:{
        url:'/mobile/getCompanyDeptSaleMonthData_new'
    },//  看板项目列表(一级项目)
    getIdcProjectList:{
        url:'/mobile/getIdcProjectList'
    },
    //  项目详情 projectId
    getIdcProjectBaseInfo:{
        url:'/mobile/getIdcProjectBaseInfo'
    },
    //  查询项目成员  projectId
    getIdcProjectMemberLists:{
        url:'/mobile/getIdcProjectMemberLists'
    },
    //   查询项目进度(周报列表) userId projectId
    queryWeeklyByProject:{
        url:'/mobile/queryWeeklyByProject'
    },
    //   projectId 项目ID dateType(时间类型 week  month season year sum) conpanyId 公司ID
    getSubProjectSaleData:{
        url:'/mobile/getSubProjectSaleData'
    },
    /**
     * 订单明细列表
     * projectId 主项目ID projectId_sub 子项目ID  (就是项目业务数据中的 projectId) yearMonth  年月
     * dateType (week  month season year sum) conpanyId  公司ID  saleMainId  员工ID  publicId 合作商ID  
     * orderType (订单类型 参考前面的订单列表)  queryType  fx 分销订单  cwsr  财务收入订单 step  page
     * **/
    getProjectOrderList:{
        url:'/mobile/getProjectOrderList'
    },
    // 项目看板  projectId 累计采购、销售、库存
    getIdcProjectSumMoney:{
        url: '/mobile/getIdcProjectSumMoney'
    },
    // 项目看板  projectId yearMonth dateType conpanyId 子项目采购数据
    getSubProjectCgData:{
        url: '/mobile/getSubProjectCgData'
    },

     // yearMonth  conpanyId  dateType  查询公司维度预付应收账款
    getCompanyZjData:{
        url: '/mobile/getCompanyZjData'
    },
    // yearMonth  conpanyId  dateType  查询合作商维度预付款 
    getPartnerZjYfData:{
        url: '/mobile/getPartnerZjYfData'
    },
    //  yearMonth  conpanyId  dateType  查询合作商维度应收账款
    getPartnerYsZjData:{
        url: '/mobile/getPartnerYsZjData'
    },
    // yearMonth  conpanyId  dateType sumType (公司维度  company 合作商维度  partner) 
    // subType(预付 yf or 应收  ys)  keyWords (合作商名称) step page 查询应收、预付订单明细列表
    getYfYsDataList:{
        url: '/mobile/getYfYsDataList'
    },
};
